export const GET_USER_ADDRESS = "GET_USER_ADDRESS";
export const SAVE_ADDRESS = "SAVE_ADDRESS";
export const DELETE_ADDRESS = "DELETE_ADDRESS";
export const SET_DEFAULT = "SET_DEFAULT";